export const IMAGE_UPLOADER_STORAGE =
  "https://storage.gqspindonesia.org/upload";
